const FAQ2 = () => {
    return (
        <div>
            <h3>Booking</h3>
            <details>
                <summary>How can I book a tour?</summary>
                <p>You can simply send me a message indicating which tour you'd like to book on which date. I will reply with my availabilities and then we can move forward.</p>
            </details>
            <details>
                <summary>Do I need to pay in advance?</summary>
                <p>No, you can pay on site with an Interac transfer, Paypal, or in cash.</p>
            </details>
            <details>
                <summary>Can I know your availabilities?</summary>
                <p>Unfortunately, I don't have a calendar on my website. I would have to change it every two days. The best would be to tell me when you'll be in Montreal, and then I would tell you which days work for me.</p>
            </details>
            <details>
                <summary>I've booked a visit to the Plateau, but they're forecasting a lot of rain. Can I visit the underground city instead?</summary>
                <p>Great idea! It certainly is possible!</p>
            </details>
        </div>
    )
}

export default FAQ2;